import React from "react";
import UserRow from "./UserRow/UserRow";
import styles from "./UserList.module.css";

import type { AdminUser } from "../../../slices/adminUser/adminUserSlice";

interface UserListProps {
  users: AdminUser[];
}

const UserList: React.FC<UserListProps> = ({ users }) => {
  if (!users.length) {
    return (
      <div className={styles.Empty}>
        Brak użytkowników do wyświetlenia.
      </div>
    );
  }

  return (
    <div className={styles.List}>
      <div className={styles.Header}>
        <div>Użytkownik:</div>
        <div>Do zapłaty:</div>
        <div>Ostatnie logowanie:</div>
        <div>Rejestracja:</div>
      </div>

      {users.map((user) => (
        <UserRow
          key={user._id}
          _id={user._id}
          name={user.name}
          email={user.email}
          outstandingBalance={user.outstandingBalance}
          lastLoginAt={user.lastLoginAt}
          createdAt={user.createdAt}
        />
      ))}
    </div>
  );
};

export default UserList;